var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Launching in:\n  "),_c('Countdown',{attrs:{"deadline":"2021-12-25 00:00:00"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }